import React from 'react';
import PublicNavbar from '../components/PublicNavbar';
import PublicFooter from '../components/PublicFooter';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

export default function SuccessStories() {
  const stories = [
    { name: "Rahul S.", exam: "JEE Topper", text: "Cracked JEE with the help of AI practice tests. The doubt solving was instant, allowing me to prepare efficiently without wasting time.", img: "11" },
    { name: "Priya M.", exam: "Placed at Google", text: "The placement preparation and coding courses are top-notch. Mock interviews helped me a lot in building confidence.", img: "5" },
    { name: "Amit K.", exam: "UPSC Cleared", text: "Structured live classes and comprehensive notes made my preparation journey incredibly smooth and focused.", img: "12" },
    { name: "Sneha R.", exam: "NEET Top Ranker", text: "The teachers here are exceptional. Their guidance and the rigorous mock tests were the key to my success.", img: "9" },
    { name: "Vikram T.", exam: "Data Scientist", text: "Transitioned from a non-tech background to a Data Scientist in just 6 months thanks to the structured learning path.", img: "15" },
    { name: "Anjali D.", exam: "Board Exams Topper", text: "The personal attention and AI-driven revision tools ensured I scored 98% in my final board exams.", img: "2" }
  ];

  return (
    <div className="min-h-screen bg-slate-50 font-['Inter',sans-serif]">
      <PublicNavbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-white relative">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="text-5xl md:text-6xl font-black text-slate-900 mb-6 tracking-tight">
            Student <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-600 to-purple-600">Success Stories</span>
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="text-lg md:text-xl text-slate-600 leading-relaxed max-w-2xl mx-auto">
            Don't just take our word for it. Hear from the thousands of students who have transformed their careers and achieved their academic goals with us.
          </motion.p>
        </div>
      </section>

      {/* Stories Grid */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 gap-y-16 mt-8">
            {stories.map((testimonial, i) => (
              <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.1 }} viewport={{ once: true }} key={i} className="bg-white p-8 rounded-[2rem] shadow-sm border border-slate-100 hover:shadow-xl transition-shadow relative">
                <div className="absolute -top-10 left-8 w-20 h-20 rounded-full border-4 border-white overflow-hidden shadow-lg bg-slate-200">
                  <img src={`https://i.pravatar.cc/150?img=${testimonial.img}`} alt={testimonial.name} className="w-full h-full object-cover" />
                </div>
                <div className="mt-8 mb-4">
                  <div className="flex text-amber-400 mb-2">
                    {[1,2,3,4,5].map(star => <Star key={star} size={16} fill="currentColor" />)}
                  </div>
                  <h4 className="text-xl font-black text-slate-800">{testimonial.name}</h4>
                  <p className="text-sm font-bold text-indigo-600">{testimonial.exam}</p>
                </div>
                <p className="text-slate-600 italic leading-relaxed">"{testimonial.text}"</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-gradient-to-br from-indigo-600 to-purple-700 text-white text-center px-4 relative">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-4xl font-black mb-6">Ready to write your own success story?</h2>
          <a href="/register" className="inline-block px-10 py-4 bg-white text-indigo-600 font-black rounded-full shadow-2xl hover:scale-105 transition-transform text-lg">
            Join Us Today
          </a>
        </div>
      </section>

      <PublicFooter />
    </div>
  );
}
